import PropTypes from 'prop-types';
import React from 'react';
import Panel from './Panel.jsx';

const LogoPanel = ({
  logoUrl,
}) => (
  <Panel>
    <img
      id="logo"
      src={logoUrl}
      style={{
        marginBottom: '52px',
        width: '281px',
      }}
    />
  </Panel>
);

LogoPanel.propTypes = {
  logoUrl: PropTypes.string,
};

export default LogoPanel;
